export const SMS_CODE_BUTTON_DEFAULT_TEXT = 'app.formComponents.form.sendCode.button.smsText'
export const CALL_CODE_BUTTON_DEFAULT_TEXT = 'app.formComponents.form.sendCode.button.callText'
export const DIVIDER_BUTTON_DEFAULT_TEXT = 'app.formComponents.form.sendCode.button.divider'
export const CODE_CALL_BUTTON_DEFAULT_TEXT = 'app.formComponents.form.sendCode.button.codeCall'
export const GET_CODE_AGAIN_TEXT = 'app.formComponents.form.sendCode.getCodeAgain'
export const GET_CODE_AGAIN_BY_CALL_AND_SMS_TEXT = 'app.formComponents.form.sendCode.getCodeAgainByCallAndSms'
export const VERIFY_WITH_CODE_TEXT = 'app.formComponents.form.sendCode.verifyWithCode'
export const CALL_NUMBER_LABEL = 'app.formComponents.form.sendCode.input.callNumberLabel'
export const SMS_CODE_INPUT_LABEL = 'app.formComponents.form.sendCode.input.smsCodeLabel'
export const SMS_CODE_BUTTON_TIMEOUT_TEXT = 'app.formComponents.form.sendCode.button.timeoutText'
export const SMS_CODE_INPUT_PLACEHOLDER = 'app.formComponents.form.sendCode.input.placeholder'
export const TIMEOUT = 60
